
import './prototypes/string-to-camel-case.interface';
import './prototypes/string-to-camel-case';
import './prototypes/string-to-kebab-case.interface';
import './prototypes/string-to-kebab-case';
import './prototypes/string-to-pascal-case.interface';
import './prototypes/string-to-pascal-case';
import './prototypes/string-to-snake-case.interface';
import './prototypes/string-to-snake-case';